import { render, staticRenderFns } from "./AudioTrackSelect.vue?vue&type=template&id=00dd86fa&scoped=true"
import script from "./AudioTrackSelect.vue?vue&type=script&lang=js"
export * from "./AudioTrackSelect.vue?vue&type=script&lang=js"
import style0 from "./AudioTrackSelect.vue?vue&type=style&index=0&id=00dd86fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd86fa",
  null
  
)

export default component.exports